<div id="main-wrapper" class="layout-with-sidebar" [ngClass]="{'mini-sidebar': sidebarService.miniSidebar}">
    
    <!-- Sidebar -->
    <app-eco-sidebar></app-eco-sidebar>
    
    <!-- Main Content Area -->
    <div class="main-content" [attr.inert]="sidebarService.mobileOpen() ? '' : null">
        
        <!-- Header SimUI (sidebar-09) -->
        <app-header></app-header>
        
        <!-- Page Content -->
        <main class="content-area">
            <section class="container-fluid" style="padding: 20px; min-height: 100%; max-width: 1600px; margin: 0 auto;">
                <router-outlet></router-outlet>
            </section>
        </main>
        
    </div>
</div>
